(() => {
  const loader =
    document.currentScript || document.querySelector("script[data-quick-add-script]");
  const quickAddScript = loader?.dataset.quickAddScript;
  const quickAddStyle = loader?.dataset.quickAddStyle;
  let quickAddReadyPromise;
  let quickAddStylePromise;
  let pendingQuickAddButton = null;

  const isQuickAddReady = () => customElements.get("quick-add");

  const isScriptAlreadyLoaded = (script) => {
    if (script.dataset.loaderReady === "true") return true;
    if (
      script.readyState === "complete" ||
      script.readyState === "loaded"
    ) {
      return true;
    }
    return performance
      .getEntriesByName(script.src, "resource")
      .some((entry) => entry.responseEnd > 0);
  };

  const loadQuickAddStyles = () => {
    if (!quickAddStyle) return Promise.resolve();
    if (quickAddStylePromise) return quickAddStylePromise;

    const existingStyle = Array.from(
      document.querySelectorAll('link[rel="stylesheet"]'),
    ).find((link) => link.href === quickAddStyle);
    if (existingStyle) return Promise.resolve();

    quickAddStylePromise = new Promise((resolve, reject) => {
      const style = document.createElement("link");
      style.rel = "stylesheet";
      style.href = quickAddStyle;
      style.addEventListener("load", resolve, { once: true });
      style.addEventListener("error", reject, { once: true });
      document.head.appendChild(style);
    }).catch((error) => {
      quickAddStylePromise = null;
      throw error;
    });

    return quickAddStylePromise;
  };

  const loadQuickAdd = () => {
    if (isQuickAddReady() || !quickAddScript) return Promise.resolve();
    if (quickAddReadyPromise) return quickAddReadyPromise;

    quickAddReadyPromise = loadQuickAddStyles().then(() => new Promise((resolve, reject) => {
      const existingScript = Array.from(document.scripts).find(
        (script) => script.src === quickAddScript,
      );

      if (existingScript) {
        if (isScriptAlreadyLoaded(existingScript)) {
          existingScript.dataset.loaderReady = "true";
          resolve();
          return;
        }

        existingScript.addEventListener(
          "load",
          () => {
            existingScript.dataset.loaderReady = "true";
            resolve();
          },
          { once: true },
        );
        existingScript.addEventListener("error", reject, { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = quickAddScript;
      script.async = false;
      script.addEventListener(
        "load",
        () => {
          script.dataset.loaderReady = "true";
          resolve();
        },
        { once: true },
      );
      script.addEventListener("error", reject, { once: true });
      document.head.appendChild(script);
    }))
      .then(() => customElements.whenDefined("quick-add"))
      .catch((error) => {
        quickAddReadyPromise = null;
        throw error;
      });

    return quickAddReadyPromise;
  };

  document.addEventListener(
    "pointerdown",
    (event) => {
      if (event.target.closest("quick-add button")) loadQuickAdd();
    },
    { capture: true, passive: true },
  );

  document.addEventListener(
    "click",
    (event) => {
      const button = event.target.closest("quick-add button");
      if (!button || isQuickAddReady()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (pendingQuickAddButton) return;
      pendingQuickAddButton = button;

      loadQuickAdd()
        .then(() => {
          pendingQuickAddButton = null;
          if (button.isConnected) button.click();
        })
        .catch(() => {
          pendingQuickAddButton = null;
        });
    },
    true,
  );

  window.loadQuickAddStyles = loadQuickAddStyles;
})();
